















































import { FaturamentoPeriodo } from "@/services/dashboard.service";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import { moeda } from "@/shared/filters";

@Component({
  filters: { moeda },
})
export default class Faturamento extends Vue {
  @Prop({ default: false }) readonly loading!: boolean;
  @Prop({ default: () => new Array<FaturamentoPeriodo>() })
  readonly value!: FaturamentoPeriodo[];

  get faturamentos() {
    if (this.loading) return [];
    else return this.value;
  }
}
